
<div class="amplify-form-container" *ngIf="_show" data-test="confirm-sign-in-section">
  <div class="amplify-form-body" data-test="confirm-sign-in-body-section">
    <div
      class="amplify-form-header amplify-form-header-ionic"
      data-test="confirm-sign-in-header-section"
      >
        {{ this.amplifyService.i18n().get('Confirm your sign in code') }}
    </div>
    <ion-list>
      <ion-item lines="none">
        <ion-label class="amplify-input-label amplify-input-label-ionic" position="stacked">
          {{ this.amplifyService.i18n().get('Code *') }}
        </ion-label>
        <ion-input
          #code
          type="text"
          class="amplify-form-input"
          (input)="setCode(code.value)"
          (keyup.enter)="onConfirm()"
          data-test="confirm-sign-in-code-input"
        ></ion-input>
      </ion-item>
    </ion-list>

    <div class="amplify-form-actions">
      <div>
        <ion-button expand="block" color="primary"
          (click)="onConfirm()"
          data-test="confirm-sign-in-confirm-button"
        >{{ this.amplifyService.i18n().get('Confirm Code') }}</ion-button>
      </div>
    </div>
  </div>

  <div class="amplify-alert" *ngIf="errorMessage">
    <div class="amplify-alert-body">
      <span class="amplify-alert-icon">&#9888;</span>
      <div class="amplify-alert-message">{{ this.amplifyService.i18n().get(errorMessage) }}</div>
      <a class="amplify-alert-close" (click)="onAlertClose()">&times;</a>
    </div>
  </div>

</div>
